import { axInst } from "../Service/Service";

export const fetchmenuaccess = async (payload) => {
    try {
        const res = await axInst.post(
            `${process.env.REACT_APP_API_URL}menusAccess`,
            payload
        );
        return res.data;

    } catch (error) {
        console.error(error);
        throw error;
    }
};
